import { customAbility } from '@/models/users/user-permissions/custom-ability';
import { abilitiesPlugin } from '@casl/vue';
import Vue from 'vue';

Vue.use(abilitiesPlugin, customAbility);
